module.exports = __webpack_public_path__ + "img/small-ship-wreck-grass-1.3f4f5964.png";